/**
 *
 * CustomFormField
 *
 */
import React from 'react';
import { CustomFormFieldProps } from 'app/components/CustomForm/CustomFormFields';
import { FormTextField } from 'app/components/Forms/FormTextField';

export function CustomFormPositiveNumberText({
  formField,
  readonly,
  disabled,
  ...props
}: CustomFormFieldProps) {
  return (
    <FormTextField
      {...props}
      disabled={readonly || disabled}
      label={formField.Label}
      key={formField.Id}
      info={formField.Description ?? undefined}
      fullWidth
    />
  );
}
